<div
  class="modal-overlay"
  (click)="onOverlayClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'global.share_modal_title' | translate"
>
  <div class="modal-content">
    <button type="button" class="close-button" (click)="close()" [attr.aria-label]="'global.close' | translate">
      &times;
    </button>
    <h2 class="modal-title">{{ 'global.share_modal_title' | translate }}</h2>
    <p class="modal-description">{{ 'global.share_modal_description' | translate }}</p>

    <label class="link-label">{{ 'global.share_your_profile_link' | translate }}</label>
    <div class="link-row">
      <input type="text" class="link-input" [value]="shareUrl" readonly />
      <button type="button" class="btn btn-copy" (click)="copyShareLink()">
        <span class="copy-icon" [inlineSVG]="'/icons/share-arrow-icon.svg'"></span>
        {{ 'global.copy' | translate }}
      </button>
    </div>

    <div class="modal-actions">
      <button type="button" class="btn btn-cta btn-preview" (click)="openPreview()">
        {{ 'global.share_preview' | translate }}
      </button>
    </div>
  </div>
</div>
